export default __webpack_public_path__ + "static/media/belicosoClosed.529ace37.jpg";